import { useState } from "react";
import IexDaily from "./IexDaily";
import PriceForcastingIEXDAM from "./PriceForcastingIEXDAM";
import { DataTabs } from "../../Hppc/Demand/Data";
import IexMonthly from "./IexMonthly";

export const IntervalFilter = ["Slot", "Day", "Month"];

const PriceForecastIEXWrapper = () => {
  const [selectedTab, setSelectedTab] = useState("Slot");
  const [dataTab, setDataTab] = useState(DataTabs[0]);

  return (
    <>
      {selectedTab === "Slot" ? (
        <PriceForcastingIEXDAM
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          dataTab={dataTab}
          setDataTab={setDataTab}
        />
      ) : selectedTab === "Day" ? (
        <IexDaily
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          dataTab={dataTab}
          setDataTab={setDataTab}
        />
      ) : (
        <IexMonthly
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          dataTab={dataTab}
          setDataTab={setDataTab}
        />
      )}
    </>
  );
};

export default PriceForecastIEXWrapper;
